document.addEventListener('DOMContentLoaded', () => {
  const bulkBtn = document.getElementById('bulk-add-to-cart');
  if (!bulkBtn) return;

  bulkBtn.addEventListener('click', () => {
    const items = [];

document.querySelectorAll('.bulk-qty__input').forEach(input => {
      const qty = parseInt(input.value, 10);
      if (qty > 0) {
        items.push({
          id: input.dataset.variantId,
          quantity: qty
        });
      }
    });

    if (!items.length) {
      alert('Please enter quantities before adding to cart.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(() => window.location.href = '/cart')
    .catch(() => alert('Something went wrong. Please try again.'));
  });
});


